// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-button{margin-bottom:0}.back-button__button{color:var(--color-display);margin-bottom:0}.back-button .ui-icon{fill:var(--color-display)}", ""]);
// Exports
module.exports = exports;
